export default function initCloseAlert() {
    const alert = document.querySelector('#alert');
    const close = document.querySelector('#close-button');

    if (close != null) {
        close.onclick = function (e) {
            e.stopPropagation();
            alert.classList.add('hidden');
        };
    }
}
